export default {
    title: 'Введите данные напоминания',
    create_reminder: 'Создать напоминание',
    row_title: 'Название',
    message: 'Сообщение',
    show_reservation_time: 'Показать время бронирования в сообщении',
    send_before: 'Время отправки перед бронированием',
    type: 'Тип',
    services: 'Услуги',
    active: 'Активно',
    action: 'Действия',
    usage: 'Использование',
    price: 'Цена RSD',
    price_bam: 'Цена BAM',
    chose_type: 'Выберите тип напоминания',
    info_reminder_before_minutes: 'Время отправки может отклоняться на +/- 15 минут',
    info_reminder_before_minutes_now: 'Отправка немедленно, если до бронирования осталось менее 30 минут',
    show_time_example: 'Показать время бронирования в сообщении (например, 12.12.2024 18:00-19:00)',
    totalPrice: 'Общее использование',
    totalSmsPrice: 'Использование SMS',
    totalSmsCount: 'Количество SMS',
    totalEmailPrice: 'Использование Email',
    totalEmailCount: 'Количество Email',
    pdv_message: 'Цены указаны без НДС',
    pdv_include_message: '* НДС включен',
    select_offers_msg: 'Пожалуйста, выберите услуги',
    select_remind_before_msg: 'Пожалуйста, выберите время напоминания до бронирования',
    info_modal: {
        title: 'Информация о напоминаниях',
        text: `<h3>Информация о сервисе</h3> <p>Пожалуйста, обратите внимание на следующие условия и правила использования услуг отправки SMS и email напоминаний:</p> <ul> <li>Стоимость одного SMS-сообщения составляет <strong>{n}</strong>.</li> <li>Общее количество SMS зависит от количества символов в тексте сообщения.</li> <li>Количество символов меньше в текстах на кириллице или латинице, чем в текстах на английском алфавите.</li> <li>Общая стоимость напоминания будет указана под текстом напоминания.</li> <li>Стоимость отправки email фиксирована и составляет <strong>{m}</strong>.</li> <li>Каждое напоминание должно быть активировано командой Bookeraj.</li> <li>С вами свяжутся в течение <strong>48 часов</strong> после создания напоминания для подтверждения.</li> <li>По всем вопросам вы можете связаться с нами по email bookeraj&#64;codebuste.rs</li> <li>Время отправки напоминания может варьироваться от -15 минут до +15 минут относительно выбранного времени.</li> </ul>`,
        price: 'без НДС',
    },
}
